module.exports = __webpack_public_path__ + "img/MX-C130092A-BS-HQ.a9e78982.png";